// The 10 request types offered by this flow. `label` is exactly what's sent as `visit_type` and
// stored/validated on the backend (see backend/server.py's SERVICE_REQUEST_TYPES) — `slug` is a
// URL-friendly identifier used only client-side (query params, this lookup table).
// `extraFields` selects which ExtraFields/* component renders in the Space Details step,
// mirroring the reference mockup's own grouping (Commercial/Corporate/Institutional share one
// set of fields; everything else not covered by a specific group falls back to "generic").
export const SERVICE_TYPES = [
  {
    slug: "nursery-visit",
    label: "Visit Our Nursery",
    description: "Explore plants, sizes, varieties and availability in person.",
    icon: "Sprout",
    extraFields: "nursery",
  },
  {
    slug: "landscaping-site-visit",
    label: "Landscaping Site Visit",
    description: "Assess a space for landscape design and execution.",
    icon: "TreePine",
    extraFields: "generic",
  },
  {
    slug: "home-garden-consultation",
    label: "Home Garden Consultation",
    description: "Plan or improve your home garden.",
    icon: "Home",
    extraFields: "generic",
  },
  {
    slug: "terrace-garden-consultation",
    label: "Terrace Garden Consultation",
    description: "Plan rooftop plants, layout and irrigation.",
    icon: "Building",
    extraFields: "generic",
  },
  {
    slug: "balcony-garden-consultation",
    label: "Balcony Garden Consultation",
    description: "Choose plants for your balcony conditions.",
    icon: "Flower2",
    extraFields: "generic",
  },
  {
    slug: "farm-plantation-visit",
    label: "Farm / Plantation Visit",
    description: "Plan horticulture, forestry or agroforestry.",
    icon: "Wheat",
    extraFields: "farm",
  },
  {
    slug: "commercial-landscaping-visit",
    label: "Commercial Landscaping Visit",
    description: "Greening for commercial properties and projects.",
    icon: "Building2",
    extraFields: "commercial",
  },
  {
    slug: "corporate-garden-visit",
    label: "Corporate Garden Visit",
    description: "Office, campus and workplace greenery.",
    icon: "Briefcase",
    extraFields: "commercial",
  },
  {
    slug: "institutional-plantation-visit",
    label: "Institutional Plantation Visit",
    description: "Schools, hospitals and institutional sites.",
    icon: "School",
    extraFields: "commercial",
  },
  {
    slug: "bulk-plant-purchase-visit",
    label: "Bulk Plant Purchase Visit",
    description: "Bulk plant inspection, selection and procurement.",
    icon: "Truck",
    extraFields: "bulk",
  },
];

export const SERVICE_TYPE_BY_SLUG = Object.fromEntries(SERVICE_TYPES.map((t) => [t.slug, t]));
